import axios from "axios";

export default {
  namespaced: true,
  state: {
    pricelists: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    pricelistsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_PRICELISTS(state, payload) {
      state.pricelists = payload;
      state.isReceiving = false;
    },
    RECEIVING_PRICELISTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_PRICELIST(state, payload) {
      console.log("RECEIVED PRICELIST", payload);
      state = Object.assign(state, {
        pricelists: [...state.pricelists, payload],
        isReceiving: false,
      })
    },
    RECEIVING_PRICELIST(state) {
      state.isReceiving = true;
    },
    UPDATED_PRICELIST(state, payload) {
      console.log(state.pricelists);
      console.log(payload);
      let index = state.pricelists.findIndex(pricelist => pricelist._id === payload._id);
      state = Object.assign(state, {
        pricelists: state.pricelists.map((pricelist, i) => {
          if (i === index) {
            return Object.assign({}, pricelist, payload);
          }
          return pricelist;
        }),
        isUpdating: false,
        pricelistsMessage: 'PriceLists has been updating!',
      })
    },
    UPDATING_PRICELIST(state) {
      state.isUpdating = true;
    },
    DELETED_PRICELIST(state, payload) {
      let indexToDelete = state.pricelists.findIndex(pricelist => pricelist._id === payload._id);
      console.log(indexToDelete);
      let pricelists = [...state.pricelists];
      pricelists.splice(indexToDelete, 1);
      state = Object.assign(state, {
        pricelists: [...pricelists],
        isDeleting: false,
        idToDelete: null,
        pricelistsMessage: 'PriceList has been Deleted!',
      });
    },
    DELETING_PRICELIST(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    getPriceListsRequest({dispatch}) {
      dispatch("receivingPriceLists");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/pricelists';
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var get = {
        method: "get",
        url: url,
        headers: header,
      };
      axios(get).then(response => {
        console.log(response.data);
        dispatch("receivePriceLists", response.data);
      })
    },
    async getPriceListsByIdRequest({dispatch}, id) {
      dispatch("doNothing");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/pricelists/' + id;
      var header = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token };
      var get = { method: "get", url: url, headers: header };
      let response = await axios(get);
      return response.data;
    },
    loadPriceListRequest({dispatch}, id) {
      dispatch("receivingPriceList");
      axios.get('/pricelists/' + id).then(res => {
        dispatch("receivePriceList", res.data);
      })
    },
    updatePriceListRequest({dispatch}, payload) {
      dispatch("updatingPriceList");
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);


      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/pricelist/' + id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: payload,
      };

      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("updatePriceList", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updatePriceListImageRequest({dispatch}, payload) {
      dispatch("updatingPriceList");
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);

      var url = 'https://api.tradexc.com:3000/update/pricelist/image/' + id;
      data = new FormData();
      data.append('image', payload.pricelistimage, payload.imagename); 
      delete payload['pricelistimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("updatePriceList", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    createPriceListRequest({dispatch}, payload) {
      dispatch("receivingPriceLists");
      var url;
      var data;
      var header;
      var token = localStorage.getItem('token');

      if(payload.pricelistimage !== undefined) {
        url = 'https://api.tradexc.com:3000/insert/pricelist/withimage';
        data = new FormData();
        data.append('image', payload.pricelistimage, payload.imagename); 
        delete payload['pricelistimage'];
        for (let x in payload) {
          data.append(x, payload[x]);
        }
        header = {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + token
        };
      } else {
        url = 'https://api.tradexc.com:3000/insert/pricelist';
        data = payload;
        header = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        };
      }
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("receivePriceList", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    deletePriceListRequest({dispatch}, payload) {
      dispatch("deletingPriceList", payload);
      console.log(payload);
      axios.get('https://api.tradexc.com:3000/delete/pricelist/' + payload._id).then(() => {
        dispatch("deletePriceList", {_id: payload._id});
      })
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receivePriceLists({commit}, payload) {
      commit("RECEIVED_PRICELISTS", payload)
    },
    receivingPriceLists({commit}) {
      commit("RECEIVING_PRICELISTS")
    },
    receivePriceList({commit}, payload) {
      commit("RECEIVED_PRICELIST", payload)
    },
    receivingPriceList({commit}) {
      commit("RECEIVING_PRICELIST")
    },
    updatePriceList({commit}, payload) {
      commit("UPDATED_PRICELIST", payload)
    },
    updatingPriceList({commit}) {
      commit("UPDATING_PRICELIST")
    },
    deletePriceList({commit}, payload) {
      commit("DELETED_PRICELIST", payload)
    },
    deletingPriceList({commit}, payload) {
      commit("DELETING_PRICELIST", payload)
    }
  },
};
